export default {
    alexa: {
        tcl_assitant: "Activer la compétence - TCL Assistant",
        active_code_hint: "Entrer le code d’activation",
        active_code_placeholder: "Code d’activation",

        active_code_message: "Sur votre télé TCL, appuyez sur les Settings",
        active_code_message_path: " bouton sur votre téléphone, allez au « Système »> « Travail avec Alexa », ",
        active_code_message_part2: "sélectionnez « Signer en » ou « Obtenir le code » pour obtenir le code d'activation.",

        active_code_message_old: "Allez à ",
        active_code_message_path_old: "Paramètres/Système/Amazon Alexa/Obtenir le code ",
        active_code_message_part2_old: "sur votre téléviseur, puis entrez le code d’activation ci-dessous.",
        
        active_code_error_null: "Le code ne doit pas être vide",
        active_code_error_number: "Entrez des chiffres",
        active_code_error_bits: "Le code doit être six chiffres",
        active_code_validate: "Activer",
        active_code_message_wrong: "Le code d’activation est incorrect ou a expiré. L’obtenir à nouveau.",
        active_code_message_exception: "Vérifiez votre réseau et recommencez.",
        check_agreements_message: "Vous devez accepter tous les conditions d’utilisation de TCL Assistant.",
        agreements: [
            "J’accepte la politique de confidentialité de TCL",
            "J’accepte la ",
            " de TCL."
        ],
        privacy_policy: "politique de confidentialité",

        grant_hint: "Autoriser TCL à effectuer des opérations.",
        grant_message_success: "Autorisation acceptée.",
        grant_message_fail: "Autorisation rejetée, rentrez le code d’activation.",
        grant_allow: "Autoriser",

        console_welcome_prompt: "Bienvenue sur TCL Alexa Console",
        empty_message: "",
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/locale/lang/fr.js
// module id = null
// module chunks = 